/**
 * Created by abbeymart on 2016-12-21.
 */
import type { RouteRecordRaw } from 'vue-router';

export const serviceRoutes: Array<RouteRecordRaw> = [
  {
    path: '/service',
    name: 'service',
    redirect: '/service/list',
    component: () => import('pages/central/service/McService.vue'),
    meta: {
      title: 'Services Repository',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'serviceList',
        component: () => import('pages/central/service/ServiceList.vue'),
        meta: {
          title: 'Services Repository List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'serviceDetail',
        component: () => import('pages/central/service/ServiceDetail.vue'),
        meta: {
          title: 'Service Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'serviceNew',
        component: () => import('pages/central/service/ServiceNew.vue'),
        meta: {
          title: 'New Service',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'serviceExplorer',
        component: () => import('pages/central/service/ServiceExplorerDtable.vue'),
        meta: {
          title: 'Services Repository Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
